import React, { useMemo, useCallback } from 'react'
import Grid from '@material-ui/core/Grid'
import { useSelector, useDispatch } from 'react-redux'

import { number } from 'Utils/Validators/formValidation'
import { processInventoryMovement } from 'Reducers/Inventory/actions'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { Input } from 'Components/Form/Input'
import Button from 'Components/Form/Button'
import Form from 'Components/Form'

import { useInventoryRequests } from '../../gql'
import { useTypeAndClientHashmap } from '../../utils'

const InventoryEditModal = props => {
  const { handleCancel, handleConfirm, item, cityId } = props
  const { editInventoryItem } = useInventoryRequests()
  const dispatch = useDispatch()
  const { clients } = useSelector(state => ({
    clients: state.clients.clientsList,
  }))

  const { typesHashmap } = useTypeAndClientHashmap()

  const { type, client } = useMemo(() => {
    const type = typesHashmap[item.typeId].name
    const client = clients.find(client => client.id === item.clientId)
    return { type, client }
  }, [item, typesHashmap])

  const onConfirm = useCallback(
    async (e, { data }) => {
      const { quantity, tag } = data
      if (tag && tag.value !== item.tag) {
        await editInventoryItem({ id: Number(item.id), tag: tag.value })
        handleConfirm()
      }

      if (quantity.value !== item.initialAmount) {
        const adjustment = -(item.initialAmount - quantity.value)
        dispatch(
          processInventoryMovement({
            cityId: Number(cityId),
            quantity: adjustment,
            inventoryId: Number(item.id),
            ambassadorId: null,
            comments:
              adjustment < 0
                ? 'Deleted on inventory page.'
                : 'Added on inventory page.',
            movement: 0,
            dateTime: new Date().toISOString(),
          }),
        )
        setTimeout(handleConfirm, 1000)
      }
    },
    [item, cityId],
  )

  return (
    <Modal show onHide={handleCancel}>
      <Form>
        <ModalHeader closeButton>
          <ModalTitle>
            Edit {type} "{item.description}" for {client.name}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Grid spacing={3} container>
            <Grid item xs={6}>
              <Input
                name="quantity"
                label="Quantity"
                value={item.initialAmount}
                validator={[number]}
              />
            </Grid>
            {item.typeId == 3 && (
              <Grid item xs={6}>
                <Input name="tag" label="Tag" value={item.tag} />
              </Grid>
            )}
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            className="submit-button"
            value="Cancel"
            onClick={handleCancel}
          />
          <Button value="Go" onClick={onConfirm} />
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default InventoryEditModal



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Inventory/components/EditModal/index.js